import React, {useEffect, useMemo, useState} from 'react';
import { useTranslation } from 'react-i18next';
import Table from '../../tables/Table';

import useCustomTable from '../../tables/useCustomTable';
import * as Format from "../../Format";
import Pagination from "../../tables/Pagination";
import Block from "../../Block";
import {OsIcon} from "../../OsIcon";
import versionCompare from "../../../services/versionCompare";
import FilterButton, {FilterGroup} from "../../FilterButton";
import TableSearch from "../../tables/TableSearch";

const ConsentBySdkTable = ({data = [], isSuccess, isFetching: isLoading, refetch}) => {

  const { t } = useTranslation();

  const {
    tableProps,
    paginationProps,
    tableSearchProps,
    tableFilterProps
  } = useCustomTable({
    sortable: true,
    paginate: true,
    sortBy: {sdkVersion: 'asc'},
    initialFilters: [{id: "productionDate", value: ["production"]}]
  });

  const columns = [{
    Header: 'Version',
    accessor: 'sdkVersion',
    sortType: (rowA, rowB, id, desc) => (versionCompare(rowB.original.sdkVersion,rowA.original.sdkVersion))
  },{
    Header: 'OS',
    id: 'os',
    Cell: ({row}) => (<OsIcon os={row.original.os} style={{fontSize: "2em"}} />),
  },{
    Header: t("cmp.analytics.metrics.testDate"),
    accessor: 'testDate',
    format: 'date'
  },{
    Header: t("cmp.analytics.metrics.productionDate"),
    accessor: 'productionDate',
    format: 'date',
    filter: (rows, columnIds, filterValue) => {
      const columnId = columnIds[0]
      if (filterValue) {
        return rows.filter(row => {
          return filterValue.map(value => {
            return (value == "production" && !!row.values[columnId]) || (value == "test" && !row.values[columnId])
          }).some(x => x)
        })
      } else {
        return rows
      }
    }
  },{
    Header: t("cmp.analytics.metrics.devices"),
    accessor: 'devices',
  },{
    Header: t("cmp.analytics.metrics.devicesWithCmpPresented"),
    accessor: 'devicesWithCmpPresented',
  },{
    Header: t("cmp.analytics.metrics.presentationRate"),
    Cell: ({row}) => <Format.Percent value={row.original.presentationRate*100}/>,
    accessor: 'presentationRate',
  },{
    Header: t("cmp.analytics.metrics.consentedDevices"),
    accessor: 'consentedDevices',
  },{
    Header: t("cmp.analytics.metrics.consentRate"),
    Cell: ({row}) => <Format.Percent value={row.original.consentRate*100}/>,
    accessor: 'consentRate',
  }
  ];

  const dataToTableRow = (el) => ({
    ...el,
    presentationRate: (el.devices || 0) > 0 ? el.devicesWithCmpPresented/el.devices : 0,
    consentRate: (el.devicesWithCmpPresented || 0) > 0 ? el.consentedDevices/el.devicesWithCmpPresented : 0
  })
  const tableData = useMemo(()=>{
    return data.map((row) => (dataToTableRow(row)))
  }, [data])

  return (
    <>
      <FilterGroup {...tableFilterProps}>
        <FilterButton
          title={t("cmp.analytics.metrics.environment")}
          options={["production", "test"]}
          search={false}
          includeAll={true}
          name="productionDate"/>
        <TableSearch {...tableSearchProps} style={{float: "right"}}/>
      </FilterGroup>
      <Block isLoading={isLoading} isSuccess={isSuccess}>
        <Table noPadding data={tableData} columns={columns} {...tableProps} />
      </Block>
      {isSuccess && !isLoading && <Pagination {...paginationProps}/>}
  </>)
}

export default ConsentBySdkTable
